module.exports = __webpack_public_path__ + "assets/svg/Icons/32/logout-gray-242cd4.svg";